import type { SyncOperation } from '../../services/api'

export type SyncStatus = SyncOperation['status']

export const SYNC_STATUS_LABELS: Record<SyncStatus, string> = {
  pending: 'Pending',
  running: 'Running',
  completed: 'Completed',
  failed: 'Failed',
  cancelled: 'Cancelled',
}

export const SYNC_STATUS_QUEUED_LABEL = 'Queued'

export const SYSTEM_LABELS: Record<string, string> = {
  lightspeed: 'Lightspeed',
  xero: 'Xero',
  skimmer: 'Skimmer',
}

export const formatSystemName = (system: string): string =>
  SYSTEM_LABELS[system.toLowerCase()] ?? system
